import React from 'react';

import { UiKit } from 'components';
import { useProductReturnWindowConfig } from '../context';

/**
 * @param {Object} props
 * @param {import('utils/types').ButtonSize} props.size
 * @param {import('utils/types').ButtonVariant} props.variant
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 */
export default function Trigger({
  size = 'md',
  className = '',
  children = null
}) {
  const { mode, selectedType, onOpenForm } = useProductReturnWindowConfig();

  // For edit mode, show a direct button
  if (mode === 'edit') {
    return (
      <UiKit.Button
        size={size}
        variant="ghost"
        className={className}
        onClick={() => onOpenForm(selectedType)}
      >
        {children}
      </UiKit.Button>
    );
  }

  // For create mode, show dropdown to select type
  return (
    <UiKit.Dropdown className={className}>
      <UiKit.Dropdown.Trigger size={size}>{children}</UiKit.Dropdown.Trigger>
      <UiKit.Dropdown.Menu>
        <UiKit.Dropdown.Option onClick={() => onOpenForm('SKU')}>
          Product SKU
        </UiKit.Dropdown.Option>
        <UiKit.Dropdown.Option onClick={() => onOpenForm('TYPE')}>
          Product Type
        </UiKit.Dropdown.Option>
      </UiKit.Dropdown.Menu>
    </UiKit.Dropdown>
  );
}
